import { InfoCircleOutlined } from '@ant-design/icons';
import { fetchBuyStorage, postStorageUpgrade, postPayuStorageUpgrade } from 'actions/digitalLibrary';
import { setSubscriptionSelectedTab, getUserProfileDetails } from 'actions/profileNew';
import { Alert, Modal, Typography } from 'antd';
import { Button } from 'components/Button';
import moment from 'moment';
import React, { useState, useEffect, useRef } from 'react'
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { postCashfreeOrder } from 'actions/fees';
import { Api } from 'services';
import { redirectToPayU, openPayuLoadingWindow } from 'pages/profile/paymentGateway';
import PaymentDetailsModal, { getMissingPaymentDetails, formatBillingAddress } from 'components/paymentDetailsModal';

const PAYU_WINDOW_NAME = 'payuPaymentWindow';

const SubscriptionModal = ({ isModalVisible, setModalVisible,storeSubscriptionPlanData, subscriptionDetails, setPageLoader, postStorageUpgrade, postPayuStorageUpgrade, currentPlan, fetchBuyStorage, postCashfreeOrder, user, setSubscriptionSelectedTab, userDetails, getUserProfileDetails }) => {
  console.log("AA-storeSubscriptionPlanData1",storeSubscriptionPlanData);
    const [payLoader, setPayLoader] = useState(false);
    const history = useHistory();
    const payuWindowRef = useRef(null);
    const pendingPaymentRef = useRef(null);
    // PayU refuses an order without a billing address, so a profile missing it (or the email) is
    // completed through this modal before the order is created.
    const [isPaymentDetailsModal, setIsPaymentDetailsModal] = useState(false);
    const paymentDetailsRef = useRef(null);

    useEffect(() => {
        if (!userDetails?.id) getUserProfileDetails();
    }, []);

    const handleCancle = () => {
        // e.stopPropagation();
        setModalVisible(false)
    }

    const successCallback = () => {
        setModalVisible(false)
        fetchBuyStorage(() => setPageLoader(false))
        setSubscriptionSelectedTab('Storage')
        history.push('/subscriptions')
    }

    useEffect(() => {
        const checkPaymentWindowClosed = () => {
            if (pendingPaymentRef.current && payuWindowRef.current?.closed) {
                const object = pendingPaymentRef.current;
                pendingPaymentRef.current = null;
                setPageLoader(true);
                postPayuStorageUpgrade(object, () => setPageLoader(false), successCallback);
            }
        };
        window.addEventListener('focus', checkPaymentWindowClosed);
        document.addEventListener('visibilitychange', checkPaymentWindowClosed);
        const pollTimer = setInterval(checkPaymentWindowClosed, 1000);
        return () => {
            window.removeEventListener('focus', checkPaymentWindowClosed);
            document.removeEventListener('visibilitychange', checkPaymentWindowClosed);
            clearInterval(pollTimer);
        };
    }, []);

    const handlePayNow = (space) => {
        if (!paymentDetailsRef.current && getMissingPaymentDetails(userDetails).isMissing) {
            setIsPaymentDetailsModal(true);
            return;
        }
        proceedToPayNow(space, paymentDetailsRef.current);
    };

    const proceedToPayNow = (space, paymentDetails, savePromise) => {
        // Opened inside the click so the browser does not block it; it waits on the loading page.
        payuWindowRef.current = openPayuLoadingWindow(PAYU_WINDOW_NAME);
        setPayLoader(true);
        if (!savePromise) {
            createOrder(space, paymentDetails);
            return;
        }
        // The address has to be on the profile before the order is created.
        savePromise.then(() => createOrder(space, paymentDetails)).catch(() => {
            setPayLoader(false);
            if (payuWindowRef.current && !payuWindowRef.current.closed) {
                payuWindowRef.current.close();
            }
        });
    };

    const createOrder = (space, paymentDetails) => {
        console.log('hit',storeSubscriptionPlanData)
        const amount = (parseFloat(storeSubscriptionPlanData?.price) * 1.18 ).toFixed(2);
        const finalCost = parseFloat((parseFloat(storeSubscriptionPlanData?.price) + parseFloat(storeSubscriptionPlanData?.price) * 0.18)).toFixed(2);
        const tax = (parseFloat(storeSubscriptionPlanData?.price) * 0.18).toFixed(2);
        let params = {
            orderAmount: amount,
            orderCurrency: 'INR',
            flow: 'feev2',
            storage: space,
            finalCost,
            tax,
            planCost: storeSubscriptionPlanData?.price,
            discount: 0,
            netCostExTaxes: 0,
            endDate: storeSubscriptionPlanData?.expiryDate,
            customerDetails: {
                customer_id: user?.id?.toString() || null,
                customer_name: user?.name || null,
                customer_email: paymentDetails?.email || userDetails?.email || user?.email || null,
                customer_phone: user?.phone?.toString() || null,
                customer_address: formatBillingAddress(paymentDetails?.address || userDetails?.basicprofile?.currentAddress) || null
            }
        };
        pendingPaymentRef.current = {
            storage: space,
            finalCost,
            tax,
            planCost: storeSubscriptionPlanData?.price,
            discount: 0,
            netCostExTaxes: 0,
            endDate: storeSubscriptionPlanData?.expiryDate,
            isTest: true,
        };
        // postCashfreeOrder(params, (response) => openCashFree({ ...response, amount, space }));
        postCashfreeOrder(params, (response) => {
            setPayLoader(false);
            // The order id is generated by the backend and comes back as txnid, so it can only be
            // attached once the order exists. Treat a response without one as a failure: the
            // poller above could not confirm the payment without it.
            if (response?.txnid) {
                pendingPaymentRef.current = { ...pendingPaymentRef.current, orderId: response.txnid };
                redirectToPayU(response, PAYU_WINDOW_NAME);
            } else {
                pendingPaymentRef.current = null;
                if (payuWindowRef.current && !payuWindowRef.current.closed) {
                    payuWindowRef.current.close();
                }
            }
        });
    };

    const openCashFree = (response) => {
        const cashfree = Cashfree({
             mode: Api._headers?.orgurl === "test.aulas.ai" ? "sandbox" : "production",
            // other configuration options
        });
        let checkoutOptions = {
            paymentSessionId: response.payment_session_id,
            redirectTarget: "_modal",
        }
        cashfree.checkout(checkoutOptions).then(function (result) {
            if (result.error) {
                alert(result.error.message)
            }
            if (result?.paymentDetails?.paymentMessage) {
                let object = {
                    storage: response.space,
                    finalCost: parseFloat((parseFloat(storeSubscriptionPlanData?.price) + parseFloat(storeSubscriptionPlanData?.price) * 0.18)).toFixed(2),
                    tax: (parseFloat(storeSubscriptionPlanData?.price) * 0.18).toFixed(2),
                    planCost: storeSubscriptionPlanData?.price,
                    discount: 0,
                    netCostExTaxes: 0,
                    endDate: storeSubscriptionPlanData?.expiryDate,
                    orderId:response.order_id,
                }
                setPageLoader(true)
                setModalVisible(false)
                postStorageUpgrade(object, () => setPageLoader(false), successCallback)
            }
        });
    }

    return (
        <Modal
            className="subscriptionLibrary"
            visible={isModalVisible}
            closable={true}
            footer={false}
            onCancel={() => handleCancle()}
            maskClosable={true}
        >

            <div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
                <div className='text-heading-library' style={{ width: '100%', textAlign: 'center', fontSize: '18px', marginTop: '10px', marginBottom: '10px' }}>
                    Plan Details
                </div>
                <div className='text-heading-library' style={{ fontSize: '24px' }}>
                    {subscriptionDetails?.space}
                </div>
                <div style={{ width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-around', marginBottom: '15px', marginTop: '5px' }}>
                    <div style={{ width: '100%', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
                        <Typography.Text style={{ fontSize: '13px', color: '#191919', fontWeight: '500' }}>Starting today</Typography.Text>
                        <Typography.Text style={{ fontSize: '13px', color: '#191919', fontWeight: '500' }}>₹ {storeSubscriptionPlanData?.price}/ Year</Typography.Text>
                    </div>
                    <div style={{ width: '100%', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
                        <Typography.Text style={{ fontSize: '13px', color: '#191919', fontWeight: '500' }}>Next billing date</Typography.Text>
                        <Typography.Text style={{ fontSize: '13px', color: '#191919', fontWeight: '500' }}>{(moment(storeSubscriptionPlanData?.expiryDate).format('DD-MM-YYYY'))}</Typography.Text>
                    </div>
                </div>
                <div style={{ width: '100%', display: 'flex', flexDirection: 'column' }} >
                    <Typography.Text className='text-content-library'>Amount details</Typography.Text>
                    <div style={{ width: '100%', padding: '10px', border: '1px solid #E6E6E6', borderRadius: '14px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                        <div style={{ width: '100%', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', marginBottom: '5px' }}>
                            <Typography.Text style={{ fontSize: '13px', color: '#191919', fontWeight: '500' }}>Subtotal</Typography.Text>
                            <Typography.Text style={{ fontSize: '13px', color: '#191919', fontWeight: '500' }}>₹ {storeSubscriptionPlanData?.price}</Typography.Text>
                        </div>
                        <div style={{ width: '100%', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', marginBottom: '5px' }}>
                            <Typography.Text className='text-content-library' style={{ fontSize: '13px' }}>IGST</Typography.Text>
                            <Typography.Text className='text-content-library' style={{ fontSize: '13px' }}>+ ₹ {parseFloat((0.18 * parseFloat(storeSubscriptionPlanData?.price)).toFixed(2))}</Typography.Text>
                        </div>
                        <div style={{ width: '100%', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', borderTop: '1px solid #E6E6E6', borderBottom: '1px solid #E6E6E6', marginBottom: '5px' }}>
                            <Typography.Text style={{ fontSize: '14px', color: '#191919', fontWeight: '600' }}>Total payable</Typography.Text>
                            <Typography.Text style={{ fontSize: '14px', color: '#191919', fontWeight: '600' }}>₹ {parseFloat(parseFloat(1.18 * parseFloat(storeSubscriptionPlanData?.price)).toFixed(2))}</Typography.Text>
                        </div>
                    </div>
                </div>
                <div>
                    <Alert message="You will have to renew the subscription  after 1 year" showIcon icon={<InfoCircleOutlined />} style={{ backgroundColor: '#FFFFFF', color: '#636363', border: 'none', fontSize: '11px' }} />
                </div>
                <center>
                <div className='r-c-sb' style={{display:"flex", width: '70%',marginBottom: '10px', marginTop: '10px' }}>
                    <Button type='default' style={{  width: '120px', marginRight: '5px' }} disabled={payLoader} onClick={() => handleCancle()}>Cancel</Button>
                    <Button type='primary' style={{  width: '120px', marginLeft: '5px' }} loading={payLoader} disabled={payLoader} onClick={() => handlePayNow(subscriptionDetails?.space)}>Pay</Button>
                </div>
                </center>
            </div>



            {isPaymentDetailsModal &&
                <PaymentDetailsModal
                    visible={isPaymentDetailsModal}
                    onCancel={() => setIsPaymentDetailsModal(false)}
                    onProceed={(details, savePromise) => {
                        paymentDetailsRef.current = details;
                        setIsPaymentDetailsModal(false);
                        proceedToPayNow(subscriptionDetails?.space, details, savePromise);
                    }}
                />}
        </Modal >
    )
}


const mapStateToProps = (state) => {
    const {
    } = state.digitalLibrary;
    const { user } = state.session;
    const { userDetails } = state.profileNew;
    return {
        user,
        userDetails,
    };
};

const mapDispatchToProps = (dispatch) => ({
    fetchBuyStorage: (callback) => dispatch(fetchBuyStorage(callback)),
    postStorageUpgrade: (object, callback, successCallback) => dispatch(postStorageUpgrade(object, callback, successCallback)),
    postPayuStorageUpgrade: (object, callback, successCallback) => dispatch(postPayuStorageUpgrade(object, callback, successCallback)),
    postCashfreeOrder: (params, callback) => dispatch(postCashfreeOrder(params, callback)),
    setSubscriptionSelectedTab: (tab) => dispatch(setSubscriptionSelectedTab(tab)),
    getUserProfileDetails: (callback) => dispatch(getUserProfileDetails(callback)),
    // setAulasCareChat: (chat) => dispatch(setAulasCareChat(chat))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SubscriptionModal);